<div class="container-fluid new-alert">
  <div>
    <div class="row rectangle-alertas">
      <div
        class="col-12 d-flex justify-content-between align-items-center px-4"
        >
        <span class="title">{{'edp.emarket.novo.alerta.criar.alerta' | translate}}</span>
      </div>
    </div>
  </div>

  <form [formGroup]="newAlertForm" (ngSubmit)="onSubmit()" class="px-2">
    <div class="row mt-3">
      <div class="col-12 col-md-8 offset-md-2 px-0">
        <span class="form-label ml-3">{{'edp.emarket.novo.alerta.Contrato' | translate}}</span>
        <mat-form-field class="col-12 pt-1" floatLabel="never">
          <input
            matInput
            formControlName="product"
            [matAutocomplete]="auto"
            placeholder="{{'edp.emarket.nova.sinalizacao.placeholder' | translate}}"
            />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="new-alert-autocomplete">
            @for (option of filteredOptions | async; track option) {
              <mat-option
                [value]="option"
                >
                {{ option.ns.split('_').join(' ') }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-6 col-md-4 offset-md-2 px-2">
        <div class="form-group pl-2 variation-container">
          <app-variation-select></app-variation-select>
        </div>
      </div>

      <div class="col-6 col-md-4 px-2">
        <div class="form-group pr-2">
          <app-price-input [form]="newAlertForm"></app-price-input>
        </div>
      </div>
    </div>

    <div class="row px-3">
      <div
        class="col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-0"
        >
        <button class="btn bg w-100" type="submit" id="btn-confirm" [disabled]="newAlertForm.invalid || pending">
          @if (pending) {
            <span class="spinner-border" style="width: 1.25rem; height: 1.25rem;" role="status" aria-hidden="true"></span>
          } @else {
            <span class="bg-text">{{'edp.emarket.detalhe.confirmar' | translate}}</span>
          }
        </button>
      </div>
    </div>
  </form>

  <div class="row my-3 px-4">
    <div
      class="col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-0"
      >
      <button class="btn bg-2 w-100" routerLink="/manageAlerts" id="btn-cancel">
        <span class="bg-text">{{'edp.emarket.detalhe.cancelar' | translate}}</span>
      </button>
    </div>
  </div>
</div>
